import React, { PropsWithChildren, useEffect } from "react"

import { Box } from "src/UILibrary"

import { Backdrop, CircularProgress, Snackbar } from "@mui/material"
import { useLocation } from "react-router-dom"
import { useRecoilState } from "recoil"
import { SNACKBAR_TYPES } from "src/modules/const"
import { ShowHeader } from "src/states/showHeader"
import { ShowProgress } from "src/states/showProgress"
import { ShowToast } from "src/states/showToast"
import Footer from "./Footer"
import Header from "./Header"
import ScrollToTop from "./scrollToTop"

const Layout: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const path = useLocation()

  const [showHeader] = useRecoilState(ShowHeader)
  const [showToast, setShowToast] = useRecoilState(ShowToast)
  const [showProgress] = useRecoilState(ShowProgress)

  useEffect(() => {
    if (showToast.show) {
      setTimeout(() => {
        setShowToast({ show: false, text: "", type: showToast.type })
      }, 5000)
    }
  }, [showToast])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [path])

  const snackBarColor = () => {
    switch (showToast.type) {
      case SNACKBAR_TYPES.ERROR:
        return "#D32F2F"
      case SNACKBAR_TYPES.WARNING:
        return "#F57C00"
      case SNACKBAR_TYPES.INFORMATION:
        return "#0288D1"
      case SNACKBAR_TYPES.SUCCESS:
        return "#388E3C"
    }
    return "black"
  }

  return (
    <Box className="page-container">
      {showHeader && <Header />}
      {children}
      {showHeader && <Footer />}
      <Snackbar
        open={showToast.show}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        message={showToast.text}
        ContentProps={{ sx: { bgcolor: snackBarColor(), fontSize: "18px" } }}
      ></Snackbar>
      <Backdrop sx={{ color: "#fff", zIndex: 10000 }} open={showProgress}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <ScrollToTop />
    </Box>
  )
}

export default Layout
